import React, {useState, useEffect, Fragment} from 'react';
import {Col, Container, Row} from 'reactstrap';
import {Breadcrumbs} from '../../../../AbstractElements';
import MyProfileEdit from './MyProfile';
import UserTable from './UserTable';
import ManageUsers from "../../../../api/ManageUsers";

const UsersEditContain = () => {

    const [users, setUsers] = useState([]);


    function loadUsers() {
        ManageUsers.loadUsers()
            .then(response => {
                setUsers(response.data.data)
            })
            .catch(error => {
                console.error("error ::: ", error)
            })
    }

    useEffect(() => {
        loadUsers();
    }, [])

    return (
        <Fragment>
            <Breadcrumbs mainTitle='Gestion des utilisateurs' parent='Gestion' title='Utilisateurs'/>
            <Container fluid={true}>
                <div className='edit-profile'>
                    <Row>
                        <Col xl='4'>
                            <MyProfileEdit reloadAction={loadUsers}/>
                        </Col>
                        <Col md='8'>
                            <UserTable users={users} setusers={setUsers} reloadAction={loadUsers}/>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    );
};
export default UsersEditContain;
